import { useCallback, useEffect } from 'react';
import AddressAutoComplete, {
  AddressCoords,
} from 'components/elements/AddressAutoComplete';
import { useGlobalGoogleMapPin, useMapCenter, useMapRadius, useMapZoom } from 'state/map';
import { useSearchQuery } from 'state/queryParams';
import { trackSearch } from 'utils/analytics';

const searchInputStyle = {
  boxShadow: '0px 8px 16px 0px #0000001F',
  height: '48px',
};

export const PlacesAutocomplete = () => {
  const { updateRadius } = useMapRadius();
  const { updateGoogleMapPin } = useGlobalGoogleMapPin();
  const [, setMapCenter] = useMapCenter();
  const [, setMapZoom] = useMapZoom();
  const [search, setSearch] = useSearchQuery();

  useEffect(() => {
    if (!search) {
      updateGoogleMapPin({ latitude: 0, longitude: 0 });
    }
  }, [search, updateGoogleMapPin]);

  const handleSelect = useCallback(
    (address: string, { lat, lng }: AddressCoords) => {
      setMapZoom(18);
      updateRadius({ point: [lng, lat], radius: 200 });
      setSearch(address);
      setMapCenter({ lat, lng });
      updateGoogleMapPin({ latitude: lat, longitude: lng });
      trackSearch({ search_input: address });
    },
    [updateRadius, setSearch, setMapCenter, setMapZoom, updateGoogleMapPin],
  );

  const handleClear = useCallback(() => {
    setSearch('');
    updateRadius({ point: [0, 0], radius: 0 });
    updateGoogleMapPin({ latitude: 0, longitude: 0 });
  }, [setSearch, updateRadius, updateGoogleMapPin]);

  return (
    <AddressAutoComplete
      onSelect={handleSelect}
      onClear={handleClear}
      externalValue={search ?? ''}
      placeholder="Search by address"
      sx={searchInputStyle}
    />
  );
};
